Vue.asyncComponent('cms-dark-mode-control', {
    data() {
        return {
            autoMode: null,
            darkMode: null,
            currentPosition: {
                lat: 50.5039,
                lng:  4.4699
            },
            sunset: null,
            sunrise: null,
        }
    },
    watch: {
        darkMode() {
            if(this.darkMode !== this.$darkModeHandler.darkMode) {
                this.$darkModeHandler.setDarkMode(this.darkMode);
                this.autoMode = false;
            }
        },
        autoMode() {
            if(this.autoMode !== this.$darkModeHandler.autoMode) {
                this.$darkModeHandler.setAutoMode(this.autoMode);
            }
        },
        "$darkModeHandler.darkMode": {
            handler() {
                this.darkMode = this.$darkModeHandler.darkMode;
            }
        }
    },
    created() {
        this.autoMode = this.$darkModeHandler.autoMode;
        this.darkMode = this.$darkModeHandler.darkMode;
    }
}, 'cms/account/cms-dark-mode-control.html');